import { createStore } from "vuex";

let config = {
  appLang: 'en-in',
  appUrl: 'https://uzhavarbumi.com/',
  env: 'production',
  apiUrl: 'https://api.uzhavarbumi.com/v2/dealers/',
  appName: 'Uzhavarbumi® Dealer',
  appVersion: '2.47',
  appUpdated: 'Sep 04, 2026',
  appId: 'com.uzhavarbumi.dealer',
  appOpenTime: 0,
  playstoreLink: 'market://details?id=com.uzhavarbumi.dealer',
  isOnline: true,
  canShare: false,
  platform: 'ios',
  deviceInfo: {},
  api_token: null,
  browser: null,
  selectedCustomer: null,
  mapboxKey: 'pk.eyJ1IjoidXpoYXZhcmJ1bWkiLCJhIjoiY2t6bWpiaDRwMHMxYjJ4bGwwMnNheWszNiJ9.VGU0_kM14GUeX0gtGsxufQ',
  dsn: "https://cb7381c6fb2641f7acd02baa35685712@bugsink.uzhavarbumi.com/4",
  user: {
    customers: [],
    subscriptions: [],
    products: [],
    districts: [],
    groups: [],
    transactions: [],
  },
  searchSort: {},
}

if (process.env.NODE_ENV === 'development') {
  config.env = 'dev';
  // config.apiUrl = 'http://api.laravel.test/v2/dealers/';
  // config.apiUrl = 'https://api.staging.uzhavarbumi.com/v2/dealers/';
  config.apiUrl = 'https://api.uzhavarbumi.com/v2/dealers/';
}

export default createStore({
  state() {
    return config;
  }
});
